import {Typography} from '@mui/material';
import React, {Fragment, useState} from 'react';

import iso9001Seal from 'presentation/assets/images/ISO-9001-seal.webp';
import {translations} from 'presentation/translations-new';
import {CertificationDetailsDrawer} from './CertificationDetailsDrawer';
import {ButtonLink, Container, SealWrapper, TextWrapper} from './styles';

const {description, buttonText, altImageText} =
	translations['pt-br'].privateFlow.bookingFlow.qualityCertificationBanner;

export function QualityCertificationBanner() {
	const [isDrawerOpen, setIsDrawerOpen] = useState(false);

	const handleDrawerOpen = () => {
		setIsDrawerOpen(true);
	};

	const handleDrawerClose = () => {
		setIsDrawerOpen(false);
	};

	return (
		<Fragment>
			<Container>
				<TextWrapper>
					<Typography variant="body2" color="text.primary" fontWeight={600}>
						{description}
					</Typography>
					<ButtonLink variant="text" onClick={handleDrawerOpen}>
						{buttonText}
					</ButtonLink>
				</TextWrapper>
				<SealWrapper>
					<img src={iso9001Seal} alt={altImageText} />
				</SealWrapper>
			</Container>

			<CertificationDetailsDrawer
				isOpen={isDrawerOpen}
				onClose={handleDrawerClose}
				onOpen={handleDrawerOpen}
			/>
		</Fragment>
	);
}
